import React from "react";
import HeaderToolbar, { HeaderToolbarProps } from "./HeaderToolbar";

export type FilePanelHeaderToolbarProps<T> = Omit<HeaderToolbarProps<T>, "isInProjectlist" | "isFileList">;

function FilePanelHeaderToolbar<T>(props: FilePanelHeaderToolbarProps<T>) {
  const className = ["file-panel-header-toolbar", props.className].filter(Boolean).join(" ");

  return <HeaderToolbar {...props} className={className} isInProjectlist={false} isFileList={true} />;
}

export default FilePanelHeaderToolbar;
